<template>
  <b-overlay
      :show="withdrawRequests === null"
      rounded="sm"
  >
    <div v-if="withdrawRequests !== null">
      <b-modal
          id="modal-edit"
          centered
          ok-title="Approve"
          cancelTitle="Close"
          @ok="changeStatus"
      >
        <b-row>
          <b-col cols="12">
            <span>Are You Sure You Want To Approve This Withdrawal Request ? </span>
          </b-col>
        </b-row>
      </b-modal>
      <b-modal
          id="modal-delete"
          centered
          ok-title="Reject"
          cancelTitle="Close"
          @ok="deleteRequest"
      >
        <b-row>
          <b-col cols="12">
            <span>Are You Sure You Want To Reject This Withdrawal Request ? </span>
          </b-col>
        </b-row>
      </b-modal>
      <!-- Table Container Card -->
      <b-card
          no-body
          class="mb-0"
      >
        <b-col lg="12" md="12" class="my-2">
          <b-row>
            <b-col lg="3" md="12" class="my-2">
              <v-select
                  v-model="selectedStatus"
                  :options="statuses"
                  :reduce="name => name.status"
                  dir="ltr"
                  label="name"
                  placeholder="Select Status"
              />
            </b-col>

          </b-row>
          <b-form-group

          >

          </b-form-group>
        </b-col>


        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="withdrawRequests"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="Nothing found!"
        >

          <template #cell(amount)="data">

            <small>{{
                Intl.NumberFormat('en-US')
                    .format(data.item.amount)
              }} $</small>


          </template>

          <template #cell(edit)="data">
            <feather-icon @click="setSelectedRecord(data.item)" v-b-modal.modal-edit icon="EditIcon" variant="primary"
            ></feather-icon>

          </template>
          <template #cell(delete)="data">
            <feather-icon @click="setSelectedRecord(data.item)" v-b-modal.modal-delete icon="TrashIcon" variant="danger"
            ></feather-icon>

          </template>
          <template #cell(status)="data">


            <b-badge v-if=" data.item.status === 'Pending'" variant="secondary">
              Pending
            </b-badge>
            <b-badge v-if=" data.item.status === 'Accepted'" variant="success">
              Accepted
            </b-badge>
            <b-badge v-if=" data.item.status === 'Paid'" variant="success">
              Paid
            </b-badge>
            <b-badge v-if=" data.item.status === 'UnPaid'" variant="danger">
              Unpaid
            </b-badge>
            <b-badge v-if=" data.item.status === 'Rejected'" variant="danger">
              Rejected
            </b-badge>

          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <!--            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>-->
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalCount"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon style="transform: rotate(180deg)"
                                icon="ChevronLeftIcon"
                                size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </div>


  </b-overlay>
</template>

<script>

import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BLink,
  BMedia,
  BModal,
  BOverlay,
  BPagination,
  BRow,
  BTable
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { ChangeWithdrawRequestStatus, DeleteWithdrawRequest, GetAllWithdrawRequests } from '@/libs/Api/Wallet'

export default {
  title: 'Withdraw Requests',
  name: 'withdrawRequests',
  data() {
    return {
      withdrawRequests: null,
      totalCount: null,
      currentPage: 1,
      perPage: 10,
      CategoryName: '',
      selectedStatus: null,
      statuses: [
        {
          name: 'Pending',
          status: 'Pending'
        },
        {
          name: 'Accepted',
          status: 'Accepted'
        },
        {
          name: 'Rejected',
          status: 'Rejected'
        },
        {
          name: 'Paid',
          status: 'Paid'
        },
        {
          name: 'Unpaid',
          status: 'Unpaid'
        },
      ],
      myTableColumns: [
        {
          key: 'id',
          label: 'id'
        },
        {
          key: 'amount',
          label: 'amount'
        },

        {
          key: 'userName',
          label: 'Booster Full Name'
        },

        {
          key: 'cardNumber',
          label: 'Card Number'
        },
        {
          key: 'cardHolder',
          label: 'Card Holder'
        },
        {
          key: 'country',
          label: 'Country'
        },
        {
          key: 'city',
          label: 'City'
        },
        {
          key: 'zipCode',
          label: 'zip code'
        },
        {
          key: 'eWalletAccountNumber',
          label: 'eWallet Account Number'
        },

        {
          key: 'walletNetwork',
          label: 'wallet network'
        },
        {
          key: 'status',
          label: 'status'
        },
        {
          key: 'edit',
          label: 'operation'
        },
        {
          key: 'delete',
          label: 'delete'
        },
        // { key: 'parentId'},
      ],
      pageNumber: 1,
      count: 10,
      search: '',
      record: null
    }
  },
  async created() {
    await this.getAllWithdraws()
  },
  components: {

    BCard,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BModal,
    BFormSelect,
    vSelect,
  },
  watch: {
    selectedStatus: function (val) {
      this.getAllWithdraws()
    },
    currentPage: function () {
      this.getAllWithdraws()
    }
  },
  methods: {
    setSelectedRecord(item) {
      this.record = item
    },
    async changeStatus() {

      let _this = this
      let changeStatus = new ChangeWithdrawRequestStatus(_this)
      let data = {
        requestId: _this.record.id
      }
      changeStatus.setParams(data)
      await changeStatus.fetch((content) => {
        _this.getAllWithdraws()
        _this.record = null
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `success`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `Operation Successful`,
          },
        })
      }, (err) => {
        console.log(err)
      })

    },
    async deleteRequest() {

      let _this = this
      let deleteWithdrawRequest = new DeleteWithdrawRequest(_this)
      let data = {
        requestId: _this.record.id
      }
      deleteWithdrawRequest.setParams(data)
      await deleteWithdrawRequest.fetch((content) => {
        _this.getAllWithdraws()
        _this.record = null
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `success`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `Operation Successful`,
          },
        })
      }, (err) => {
        console.log(err)
      })

    },
    async getAllWithdraws() {
      let _this = this
      let getAllWithdrawRequests = new GetAllWithdrawRequests(_this)
      let data = {
        pageNumber: _this.currentPage,
        count: _this.count,
        status: _this.selectedStatus
      }
      getAllWithdrawRequests.setParams(data)
      await getAllWithdrawRequests.fetch(function (content) {
        _this.withdrawRequests = content.data.data
        _this.totalCount = content.data.totalCount
      }, function (error) {
        console.log(error)
      })
    },

  },
}
</script>

<style scoped>

</style>
